<div class="vdw-wrapper">
  <div class="card vdw-card shadow-lg border-0">
    <!-- Header com progresso -->
    <div class="card-header vdw-header bg-white border-bottom">
      <div class="d-flex align-items-center justify-content-between mb-3">
        <div>
          <h4 class="payment-processing-title mb-1">
            <i class="fa fa-camera mr-2"></i>
            <strong>Validação Facial</strong>
          </h4>
          <h5 class="payment-processing-title"><p>Capture o seu rosto para validação de identidade</p></h5>
        </div>
        <div class="vdw-device-info">
          <span class="badge badge-pill vdw-badge-device">
            <i class="fa fa-mobile-alt mr-1"></i>
            {{ obterTipoDispositivo() }}
          </span>
        </div>
      </div>
      <div class="vdw-steps">
        <div
          class="vdw-step vdw-step--small"
          [class.vdw-step--done]="step === 'successo' || step === 'enviado' || step === 'final' || step === 'error'"
          [class.vdw-step--active]="step === 'permissao' || step === 'camera' || step === 'preview'">
          <span class="vdw-step__num">
            <i
              class="fa fa-check"
              *ngIf="step === 'successo' || step === 'enviado' || step === 'final' || step === 'error'"></i>
            <ng-container *ngIf="step !== 'successo' && step !== 'enviado' && step !== 'final' && step !== 'error'">
              1
            </ng-container>
          </span>
          <span class="vdw-step__label">Permissão</span>
        </div>
        <div
          class="vdw-step vdw-step--small"
          [class.vdw-step--done]="step === 'successo' || step === 'enviado' || step === 'final' || step === 'error'"
          [class.vdw-step--active]="step === 'camera' || step === 'preview'">
          <span class="vdw-step__num">
            <i
              class="fa fa-check"
              *ngIf="step === 'successo' || step === 'enviado' || step === 'final' || step === 'error'"></i>
            <ng-container *ngIf="step !== 'successo' && step !== 'enviado' && step !== 'final' && step !== 'error'">
              2
            </ng-container>
          </span>
          <span class="vdw-step__label">Captura</span>
        </div>
        <div
          class="vdw-step vdw-step--small"
          [class.vdw-step--done]="step === 'successo' || step === 'enviado' || step === 'final' || step === 'error'">
          <span class="vdw-step__num">
            <i
              class="fa fa-check"
              *ngIf="step === 'successo' || step === 'enviado' || step === 'final' || step === 'error'"></i>
            <ng-container *ngIf="step !== 'successo' && step !== 'enviado' && step !== 'final' && step !== 'error'">
              3
            </ng-container>
          </span>
          <span class="vdw-step__label">Validação</span>
        </div>
        <div
          class="vdw-step vdw-step--small"
          [class.vdw-step--done]="step === 'final' || step === 'error'"
          [class.vdw-step--error]="step === 'error'">
          <span class="vdw-step__num">
            <i class="fa fa-check" *ngIf="step === 'final'"></i>
            <i class="fa fa-times" *ngIf="step === 'error'"></i>
            <ng-container *ngIf="step !== 'final' && step !== 'error'">4</ng-container>
          </span>
          <span class="vdw-step__label">Retorno</span>
        </div>
      </div>
    </div>

    <div class="card-body vdw-body">
      <!-- STEP: PERMISSÃO -->
      <ng-container *ngIf="step === 'permissao'">
        <div class="vdw-permission text-center py-4">
          <div class="vdw-permission-icon fa fa-key mb-3">
            <i
              class="fa fa-video"
              [class.vdw-permission-icon--denied]="!temPermissao"
              [class.vdw-permission-icon--granted]="temPermissao"></i>
          </div>

          <ng-container *ngIf="verificandoPermissao">
            <div class="spinner-border text-primary mb-3" role="status">
              <span class="sr-only">Verificando permissões...</span>
            </div>
            <h4 class="payment-processing-title mb-1 text-center">
              <strong>Aguardando acesso da câmera...!</strong>
            </h4>
            <h5 class="payment-processing-title">Por favor, precisa liberar acesso a câmera</h5>
          </ng-container>

          <ng-container *ngIf="!verificandoPermissao">
            <ng-container *ngIf="temPermissao">
              <div class="alert alert-success mb-3">
                <i class="fa fa-check-circle mr-2"></i>
                Permissão concedida com sucesso!
              </div>
              <h5 class="font-weight-bold">Câmera pronta para uso</h5>
              <p class="text-muted mb-4">Clique em "Continuar" para iniciar a captura do documento.</p>
            </ng-container>

            <ng-container *ngIf="!temPermissao">
              <div class="alert alert-danger mb-3">
                <i class="fa fa-exclamation-triangle mr-2"></i>
                {{ erroValidacao || 'Permissão da câmera negada' }}
              </div>
              <h5 class="font-weight-bold">Permissão necessária</h5>
              <p class="text-muted mb-4">
                Para validar sua identidade, precisamos acessar sua câmera. Por favor, permita o acesso nas
                configurações do navegador.
              </p>
            </ng-container>
          </ng-container>

          <div class="vdw-permission-actions">
            <button *ngIf="!temPermissao" class="btn btn-outline-warning round btn-lg" (click)="aoSolicitarPermissao()">
              <i class="fa fa-key mr-1"></i>
              Solicitar Permissão
            </button>

            <button *ngIf="temPermissao" class="btn btn-outline-primary round btn-lg" (click)="step = 'camera'">
              <i class="fa fa-camera mr-1"></i>
              Continuar
            </button>

            <button class="btn btn-outline-danger round btn-lg" (click)="cancelar()">
              <i class="fa fa-times mr-1"></i>
              Cancelar
            </button>
          </div>
        </div>
      </ng-container>

      <!-- STEP: CÂMERA -->
      <ng-container *ngIf="step === 'camera'">
        <!-- Alerta de erro da câmera -->
        <div *ngIf="errosWebcam.length > 0" class="alert alert-danger vdw-alert">
          <div class="d-flex align-items-center">
            <i class="fa fa-exclamation-triangle mr-3 vdw-alert-icon"></i>
            <div>
              <strong>Erro na câmera</strong>
              <p class="mb-0">Verifique as permissões do navegador ou envie uma imagem da galeria.</p>
            </div>
          </div>
        </div>

        <!-- Área da webcam -->
        <div class="vdw-camera-container" *ngIf="errosWebcam.length === 0">
          <div class="vdw-webcam-wrapper">
            <webcam
              [trigger]="triggerObservable"
              [switchCamera]="switchCameraObservable"
              [videoOptions]="videoOptions"
              [imageType]="'image/jpeg'"
              [imageQuality]="0.95"
              [width]="600"
              [height]="480"
              (imageCapture)="aoCapturarImagem($event)"
              (initError)="aoIniciarErro($event)"
              class="vdw-webcam"></webcam>

            <!-- Guia de posicionamento do documento -->
            <div class="vdw-document-guide">
              <div class="vdw-doc-frame">
                <div class="vdw-doc-corners">
                  <span class="vdw-corner vdw-corner--tl"></span>
                  <span class="vdw-corner vdw-corner--tr"></span>
                  <span class="vdw-corner vdw-corner--bl"></span>
                  <span class="vdw-corner vdw-corner--br"></span>
                </div>
              </div>
            </div>

            <!-- Indicador AO VIVO -->
            <div class="vdw-live-indicator">
              <span class="vdw-live-dot"></span>
              <span class="vdw-live-text">AO VIVO</span>
            </div>
          </div>
        </div>

        <!-- Dicas de captura -->
        <div class="vdw-tips-section mt-4">
          <h6 class="font-weight-bold mb-3">
            <i class="fa fa-lightbulb mr-2"></i>
            Dicas para melhor captura:
          </h6>
          <div class="row">
            <div class="col-md-6 col-sm-12 mb-2" *ngFor="let dica of dicas">
              <div
                class="vdw-tip"
                [class.vdw-tip--ok]="dica.type === 'ok'"
                [class.vdw-tip--warn]="dica.type === 'warn'">
                <span class="vdw-tip__icon">{{ dica.type === 'ok' ? '✓' : '⚠' }}</span>
                <span class="vdw-tip__label">{{ dica.label }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Ações -->
        <div class="vdw-camera-actions mt-4">
          <button
            class="btn btn-outline-success btn-lg btn-block round"
            (click)="dispararCaptura()"
            [disabled]="errosWebcam.length > 0">
            <i class="fa fa-camera mr-2"></i>
            Capturar Foto
          </button>

          <div class="vdw-divider my-3">
            <span>ou</span>
          </div>

          <label class="btn btn-outline-secondary btn-lg btn-block round" style="cursor: pointer">
            <i class="fa fa-upload mr-2"></i>
            Enviar da Galeria
            <input type="file" accept="image/*" hidden (change)="aoSelecionarArquivo($event)" />
          </label>

          <!-- Trocar câmera (mobile) -->
          <button
            *ngIf="multiplasWebcamsDisponiveis && ehMobile()"
            class="btn btn-link btn-block mt-2 vdw-btn-switch"
            (click)="trocarCamera()">
            <i class="fa fa-sync-alt mr-2"></i>
            Trocar Câmera
          </button>
        </div>
      </ng-container>

      <!-- STEP: PREVIEW -->
      <ng-container *ngIf="step === 'preview'">
        <div class="vdw-preview-section">
          <h5 class="font-weight-bold text-center mb-3">
            <i class="fa fa-search mr-2"></i>
            Verifique a imagem capturada
          </h5>
          <p class="text-muted text-center mb-4">
            Certifique-se de que o documento está legível e todas as informações estão visíveis.
          </p>

          <div class="vdw-preview-container">
            <img
              [src]="imagemCapturada?.imageAsDataUrl"
              alt="Documento capturado"
              class="vdw-preview-image img-fluid rounded shadow" />

            <!-- Overlay de validação -->
            <div class="vdw-validating-overlay" *ngIf="validando">
              <div class="vdw-spinner-container">
                <div class="spinner-border text-light vdw-spinner" role="status">
                  <span class="sr-only">Validando documento...</span>
                </div>
                <p class="text-white mt-2 mb-0">Validando documento...</p>
                <p class="text-white small">Aguarde enquanto verificamos a autenticidade.</p>
              </div>
            </div>
          </div>

          <!-- Erro de validação -->
          <div *ngIf="erroValidacao" class="alert alert-danger vdw-alert mt-3">
            <i class="fa fa-exclamation-circle mr-2"></i>
            {{ erroValidacao }}
          </div>

          <!-- Ações -->
          <div class="vdw-preview-actions mt-4">
            <button (click)="tirarFotoNovamente()" [disabled]="validando" class="btn btn-outline-warning round">
              <i class="fa fa-check mr-1"></i>
              Capturar Novamente
            </button>
            <button (click)="confirmarFoto()" class="btn spinner-border-sm btn-outline-primary round">
              <i class="fa fa-check mr-1"></i>
              Confirmar Foto
            </button>
          </div>
        </div>
      </ng-container>

      <!-- STEP: SUCESSO -->
      <ng-container *ngIf="step === 'successo'">
        <div class="vdw-success-section text-center py-4">
          <div class="vdw-success-icon mb-4">
            <i class="fa fa-check-circle"></i>
          </div>
          <h4 class="payment-processing-title mb-1">
            <i class="fa fa-camera mr-2"></i>
            <strong>Foto pronta para envio!</strong>
          </h4>

          <p class="text-muted mb-4">
            Sua foto foi capturada com sucesso. Clique no botão abaixo para enviá-la para análise.
          </p>

          <!-- Preview da imagem validada -->
          <div class="vdw-success-preview mb-4">
            <img
              [src]="imagemCapturada?.imageAsDataUrl"
              class="img-fluid rounded shadow vdw-success-image"
              style="max-height: 200px; width: auto"
              alt="Documento validado" />
          </div>

          <button class="btn btn-outline-success round btn-lg" (click)="enviarFotoParaAnaliseEmiter()">
            <i class="fa fa-send mr-2"></i>
            Enviar para Análise
          </button>
        </div>
      </ng-container>

      <!-- STEP: ENVIANDO (após clicar em enviar) -->
      <ng-container *ngIf="step === 'enviado'">
        <div class="vdw-success-section text-center py-4">
          <div class="vdw-success-icon mb-4">
            <div class="spinner-border text-success" role="status">
              <span class="sr-only">Enviando...</span>
            </div>
          </div>
          <h4 class="payment-processing-title mb-1">
            <i class="fa fa-camera mr-2"></i>
            <strong>Sua foto foi validada, aguarde o retorno.</strong>
          </h4>

          <p class="text-muted mb-4">
            Estamos processando sua foto. Por favor, aguarde enquanto enviamos para análise.
          </p>
        </div>
      </ng-container>

      <!-- STEP: FINAL (após envio para o back) -->
      <ng-container *ngIf="step === 'final'">
        <div class="vdw-success-section text-center py-4">
          <div class="vdw-success-icon mb-4">
            <i class="fa fa-check-circle"></i>
          </div>
          <h4 class="payment-processing-title mb-1">
            <i class="fa fa-camera mr-2"></i>
            <strong>Foto enviada para análise!</strong>
          </h4>

          <p class="text-muted mb-4">
            Agradecemos a confiança. Sua foto ainda está em validação e seu cadastro segue em análise. Assim que
            aprovado, você será notificado imediatamente.
          </p>

          <!-- Preview da imagem validada -->
          <div class="vdw-success-preview mb-4">
            <img
              [src]="imagemCapturada?.imageAsDataUrl"
              class="img-fluid rounded shadow vdw-success-image"
              style="max-height: 200px; width: auto"
              alt="Documento validado" />
          </div>
        </div>
      </ng-container>

      <!-- STEP: ERRO -->
      <ng-container *ngIf="step === 'error'">
        <div class="vdw-error-section text-center py-4">
          <div class="vdw-error-icon mb-4">
            <i class="fa fa-times-circle"></i>
          </div>
          <h5 class="font-weight-bold mb-3">Não foi possível validar a foto, reenvie novamente.</h5>
          <p class="text-muted mb-4">{{ erroValidacao }}</p>

          <button class="btn btn-outline-info round" (click)="tirarFotoNovamente()">
            <i class="fa fa-redo mr-2"></i>
            Tentar Novamente
          </button>

          <div class="vdw-divider my-3">
            <span>ou</span>
          </div>

          <label class="btn btn-outline-secondary btn-block vdw-btn-upload" style="cursor: pointer">
            <i class="fa fa-upload mr-2"></i>
            Enviar outra imagem
            <input type="file" accept="image/*" hidden (change)="aoSelecionarArquivo($event)" />
          </label>
        </div>
      </ng-container>
    </div>

    <!-- Footer de segurança -->
    <div class="card-footer vdw-footer bg-white text-center border-top">
      <div class="vdw-security-info">
        <i class="fa fa-shield-alt mr-2"></i>
        <small class="text-muted">
          Seus dados são criptografados e utilizados apenas para validação de identidade. Nenhuma informação é
          armazenada permanentemente.
        </small>
      </div>
    </div>
  </div>
</div>
